<template>
  <div class="about-us-values bg--color-09">
    <div class="container-wrapper bg--color-08">
      <div class="about-us-values__container container-new">
        <div class="about-us-values__image">
          <img :src="require('@/assets/img/about-us/values.svg')">
        </div>

        <div class="about-us-values__info">
          <span class="txt txt--36px txt--height-44px txt--44px--m txt--height-58px--m txt--color-04 txt--bold">
            {{ $t('aboutUs.valuesBlock.title') }}
          </span>

          <span class="txt txt--16px txt--height-20px txt--22px--m txt--height-30px--m txt--color-04 txt--bold">
            {{ $t('aboutUs.valuesBlock.listTitle') }}
          </span>

          <div class="about-us-values__items">
            <div
              v-for="(item, index) in $t('aboutUs.valuesBlock.items') || []"
              :key="index"
              class="about-us-values__item bg--color-01"
            >
              <span class="about-us-values__item-label txt--weight-600">{{ index + 1 }}</span>
              <span
                v-html="item"
                class="txt txt--22px txt--height-30px txt--color-04"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUsValues',
}
</script>

<style lang="scss" scoped>
.about-us-values {
  &__container {
    display: grid;
    grid-template-columns: 1fr;
    gap: toRem(24px);

    @include bp(m) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: toRem(16px);

    @include bp(m) {
      gap: toRem(24px);
    }
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: toRem(16px);

    @include bp(m) {
      gap: toRem(24px);
    }
  }

  &__item {
    padding: toRem(12px);
    display: grid;
    grid-template-columns: toRem(28px) 1fr;
    gap: toRem(10px);
    border-radius: toRem(20px);

    &-label {
      line-height: toRem(28px);
      font-size: toRem(18px);
      text-align: center;
    }
  }

  &__image {
    img {
      max-width: toRem(218px);

      @include bp(m) {
        max-width: 100%;
      }
    }
  }
}
</style>
